import * as React from "react";

import { Link } from "react-router-dom";
import { Page, PageHero, Tabs } from "src/components/common";

interface IProps {
	children?: any;
	match?: any;
	location?: any;
}

const OrganizationRole: React.FC<IProps> = (props) => {
	const [usernameInTab, setUsernameInTab] = React.useState<string>("");

	const { userId } = props.match.params;

	const tabs = [
		{
			id: 1,
			label: "Details",
			to: `/admin/organizations/${props.match.params.organizationId}/users/${userId}/details`,
		},
	];

	return (
		<Page>
			<PageHero>
				<Link
					to={`/admin/organizations/${props.match.params.organizationId}/users`}
				>
					&lt; USERS
				</Link>
				<h1 className="mb-0">
					{Number(userId) > 0 ? usernameInTab : "New User(s)"}
				</h1>
			</PageHero>
			<Tabs className="mb-4" tabs={tabs} location={props.location} />
			{props.children(setUsernameInTab)}
		</Page>
	);
};

export default OrganizationRole;
